import(/* webpackMode: "eager" */ "/vercel/path0/app/legal/page.tsx");
